import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { SourceEnum } from '../enums/source.enum';
import { IRequiredValidators } from '../interfaces/required-validators.interface';
import { SourceConfig } from '../utils/source-config';

@Injectable({
  providedIn: 'root',
})
export class SourceService {
  private config = SourceConfig;

  constructor(private router: Router) {}

  public getSource(): string | null {
    const source =
      this.getSourceBySubdomain() || this.getSourceByActivedRoute();
    return source;
  }

  public isRequired(source: string | null): IRequiredValidators {
    return this.config.getRequiredValidators(source);
  }

  /**
   * Método responsável por verificar a presença de um sub-domínio válido,
   * um sub-domínio é válido se estiver mapeado no switch-case.
   * @returns Retorna um subdonmínio válido ou nulo caso o subdomínio seja inválido
   */
  public getSourceBySubdomain(): string | null {
    const subdomain = window.location.hostname.split('.')[0];

    switch (subdomain) {
      case SourceEnum.LCC.toLocaleLowerCase():
        return SourceEnum.LCC;
      case SourceEnum.ACOMA.toLocaleLowerCase():
        return SourceEnum.ACOMA;
      case SourceEnum.B2B.toLocaleLowerCase():
        return SourceEnum.B2B;
      case SourceEnum.VML.toLocaleLowerCase():
        return SourceEnum.VML;
      case SourceEnum.FORTTIUS.toLocaleLowerCase():
        return SourceEnum.FORTTIUS;
      case 'araujo-soares':
      case SourceEnum.ARAUJO_SOARES.toLocaleLowerCase():
        return SourceEnum.ARAUJO_SOARES;
      case 'apoio-empresas':
      case SourceEnum.APOIO_EMPRESAS.toLocaleLowerCase():
        return SourceEnum.APOIO_EMPRESAS;
      case 'avance-cred':
        return SourceEnum.AVANCECRED;
      default:
        return null;
    }
  }

  public getSourceByActivedRoute(): string | null {
    let route = this.router.routerState.snapshot.root;

    while (route.firstChild) {
      route = route.firstChild;
    }

    const source = route.data['source'] ?? null;
    return source;
  }
}
